import { MarketplaceCoupon } from '@scentregroup/shared/types'
import { ICouponCodeEntryFeedback } from '../components/coupon-code-entry'

export function getMarketplaceCouponExpiredFeedbackMessage(
  errorCode: string | null | undefined
): string {
  switch (errorCode) {
    case 'ProfileLimitReached':
      return 'Sorry, you are not eligible to redeem this promo code'
    default:
      return 'Sorry, this code has expired'
  }
}

export function isMarketplaceCouponEligible(
  coupon: MarketplaceCoupon
): coupon is Extract<
  MarketplaceCoupon,
  { __typename: 'MarketplaceCouponEligible' }
> {
  return coupon.__typename === 'MarketplaceCouponEligible'
}

export function couponApplicationFeedback(
  coupon: MarketplaceCoupon
): ICouponCodeEntryFeedback {
  switch (coupon.__typename) {
    case 'MarketplaceCouponEligible':
      return {
        status: 'success',
        message: `${coupon.code} applied`,
        showTermsAndConditionsLink: true,
        showAccountSignInComponent: false,
      }
    case 'MarketplaceCouponExpired':
      return {
        status: 'error',
        message: getMarketplaceCouponExpiredFeedbackMessage(coupon.errorCode),
        showTermsAndConditionsLink: false,
        showAccountSignInComponent: false,
      }
    case 'MarketplaceCouponInvalid': {
      const showAccountSignIn = coupon.errorCode === 'ProfileRequired'
      return {
        status: 'error',
        message: showAccountSignIn ? null : 'Sorry, this code is incorrect',
        showTermsAndConditionsLink: false,
        showAccountSignInComponent: showAccountSignIn,
      }
    }
    case 'MarketplaceCouponIneligible':
      return {
        status: 'warning',
        message:
          coupon.message || 'Sorry, some items in your cart are not eligible',
        showTermsAndConditionsLink: true,
        showAccountSignInComponent: false,
      }
  }
}

export const QUERY_FEATURE_PROMOTION = 'promotion'
